module.exports = __webpack_public_path__ + "images/about-us-header.c764f61d32083e7a17189cdc33d15201.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/about-us-header.jpg
// module id = 980
// module chunks = 0